import { useState } from 'react'
import { Eye, EyeOff, LockKeyhole, Mail, UserRound } from 'lucide-react'
import { supabase, siteUrl } from '../lib/supabase'

type Mode = 'login' | 'signup' | 'forgot'

export function AuthPage() {
  const [mode, setMode] = useState<Mode>('login')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setMessage('')
    setLoading(true)
    try {
      if (mode === 'forgot') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${siteUrl}/reset-password` })
        if (error) throw error
        setMessage('Se o e-mail estiver cadastrado, você receberá um link para redefinir sua senha.')
      } else if (mode === 'signup') {
        const { data, error } = await supabase.auth.signUp({
          email,
          password,
          options: { data: { name: name.trim() }, emailRedirectTo: `${siteUrl}/login` },
        })
        if (error) {
          if (/already|registered|exists/i.test(error.message)) { setMessage('Esse e-mail já possui cadastro.'); return }
          throw error
        }
        if (data.user?.identities?.length === 0) { setMessage('Esse e-mail já possui cadastro.'); return }
        setMessage('Usuário criado com sucesso, aguardando liberação ao sistema.')
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        const { data: profile } = await supabase.from('profiles').select('status').eq('id', data.user.id).single()
        if (profile?.status !== 'active') {
          setMessage(profile?.status === 'blocked' ? 'Seu acesso está bloqueado.' : 'Seu cadastro ainda aguarda liberação.')
        }
      }
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Não foi possível concluir a operação.')
    } finally {
      setLoading(false)
    }
  }

  const title = mode === 'login' ? 'Acesse sua conta' : mode === 'signup' ? 'Crie seu cadastro' : 'Recupere sua senha'
  return <div className="auth-shell">
    <section className="auth-hero">
      <div><h1>Suas contas organizadas.<br />Suas decisões mais simples.</h1><p>Controle vencimentos empresariais e gastos do Cartão Roly em um único lugar seguro.</p></div>
    </section>
    <section className="auth-panel"><div className="auth-card">
      <span className="eyebrow">ÁREA RESTRITA</span><h2>{title}</h2>
      <p className="muted">{mode === 'forgot' ? 'Informe seu e-mail para receber o link de redefinição.' : 'Use seus dados para continuar.'}</p>
      <form className="stack" onSubmit={submit}>
        {mode === 'signup' && <label>Nome<div className="input-icon"><UserRound size={18} /><input value={name} onChange={e => setName(e.target.value)} placeholder="Seu nome" required minLength={2} /></div></label>}
        <label>E-mail<div className="input-icon"><Mail size={18} /><input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="voce@empresa.com.br" required /></div></label>
        {mode !== 'forgot' && <label>Senha<div className="input-icon"><LockKeyhole size={18} /><input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="Mínimo de 8 caracteres" required minLength={8} /><button type="button" className="icon-button" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></div></label>}
        {message && <p className="form-message">{message}</p>}
        <button className="full" disabled={loading}>{loading ? 'Aguarde…' : mode === 'login' ? 'Entrar' : mode === 'signup' ? 'Criar cadastro' : 'Enviar link'}</button>
      </form>
      <div className="auth-links">
        {mode === 'login' && <><button onClick={() => { setMode('forgot'); setMessage('') }}>Esqueceu sua senha?</button><span>Não possui cadastro? <button onClick={() => { setMode('signup'); setMessage('') }}>Cadastre-se</button></span></>}
        {mode !== 'login' && <button onClick={() => { setMode('login'); setMessage('') }}>Voltar para o login</button>}
      </div>
    </div></section>
  </div>
}

export function ResetPasswordPage() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [message, setMessage] = useState('')

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    if (password !== confirm) return setMessage('As senhas não conferem.')
    const { error } = await supabase.auth.updateUser({ password })
    setMessage(error ? error.message : 'Senha redefinida. Você já pode acessar o sistema.')
  }
  return <div className="auth-shell"><section className="auth-card centered"><div className="brand-mark large">FR</div><h1>Defina sua nova senha</h1><form className="stack" onSubmit={submit}><label>Nova senha<input type="password" minLength={8} required value={password} onChange={e => setPassword(e.target.value)} /></label><label>Confirmação<input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} /></label>{message && <p className="form-message">{message}</p>}<button>Salvar senha</button></form></section></div>
}
